import "es6-promise/auto";
import axios from "axios";
import BootstrapVue from "bootstrap-vue";
import Vue from "vue";
import VueAuth from "@websanova/vue-auth";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
import VueFlashMessage from "vue-flash-message";
import "vue-flash-message/dist/vue-flash-message.min.css";
import Sticky from "vue-sticky-directive";
import auth from "./auth";
import router from "./routes";
import store from "./store/index";
import "./icons";
import "./vee-validate";
import "./sentry"
import {currencyFormat, formatDate, formatDatetime} from "./filters";
import App from "@/views/App";
import "./bootstrap";
import NotificationPlugin from "./plugins/notification-plugin"
import * as Sentry from "@sentry/browser";

Vue.use(BootstrapVue);

Vue.use(Sticky);

// Set Vue globally
window.Vue = Vue;

// Set Vue router
Vue.router = router;
Vue.use(VueRouter);

// Set Vue authentication
Vue.use(VueAxios, axios);

//axios.defaults.baseURL = `${process.env.MIX_APP_URL}/api`
axios.defaults.baseURL = "/api";

//Auth
Vue.use(VueAuth, auth);

//flash message
Vue.use(VueFlashMessage);

Vue.use(NotificationPlugin);

Vue.filter("formatDate", formatDate);
Vue.filter("formatDatetime", formatDatetime);
Vue.filter("currencyFormat", currencyFormat);

Vue.prototype.$eventHub = new Vue(); // Global event bus

new Vue({
    el: "#app",
    render: h => h(App),
    router,
    store,
    beforeMount() {
        this.afterConnect();
    },
    methods: {
        afterConnect() {
            window.Echo.connector.pusher.connection.bind("connected", () => {
                this.$store.dispatch("Lot/socketAvailable");
            });
            window.Echo.connector.pusher.connection.bind("connecting", () => {
                this.$store.dispatch("Lot/socketUnavailable");
            });
            window.Echo.connector.pusher.connection.bind("disconnected", () => {
                console.error('pusher:disconnected');
                Sentry.captureMessage('pusher:disconnected')
                this.$store.dispatch("Lot/socketUnavailable");
            });
            window.Echo.connector.pusher.connection.bind("unavailable", () => {
                console.error('pusher:unavailable');
                Sentry.captureMessage( 'pusher:unavailable')
                this.$store.dispatch("Lot/socketUnavailable");
            });
            window.Echo.connector.pusher.connection.bind("error", (error) => {
                console.error('pusher:error', error);
                Sentry.captureMessage('pusher:error', {error})
                this.$store.dispatch("Lot/socketUnavailable");
            });
            window.Echo.connector.pusher.connection.bind("failed", (error) => {
                console.error('pusher:failed');
                Sentry.captureMessage('pusher:failed', {error})

                window.Echo.disconnect();
                setTimeout(() => {
                    window.Echo.connect();
                    this.afterConnect();
                }, 1000);
                this.$store.dispatch("Lot/socketUnavailable");
            });
            window.Echo.leaveHard = (channel) => {
                const ch = window.Echo.channel('presence-' + channel)
                ch.unsubscribe()
                ch.subscription.unbind('pusher:subscription_error')
                ch.subscription.disconnect()
                ch.subscription.subscriptionPending = false

                window.Echo.leave(channel)
            }
        },
    },
});

